import { Locale, type LocalizedString } from "../Locale.js";

export const customCakesPathMap = {
	[Locale.cs]: "dorty-na-miru" as const,
} satisfies LocalizedString;

export const customCakesEnquiryPathMap = {
	[Locale.cs]: "poptavka-dortu" as const,
} satisfies LocalizedString;
